// extracted by mini-css-extract-plugin
module.exports = {"base":"TeamProfileQuote_base__CoeDW","content":"TeamProfileQuote_content__oDyHk","quote":"TeamProfileQuote_quote__je_HQ","author":"TeamProfileQuote_author__NeTJZ"};